import axios from 'axios';
import { getApiBaseUrl } from '../config/apiBaseUrl';

if (import.meta.env.DEV) {
  console.log('🔧 API Base URL:', getApiBaseUrl());
}

export const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token d'authentification + URL API à jour (runtime-config)
apiClient.interceptors.request.use((config) => {
  config.baseURL = getApiBaseUrl();
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer les erreurs
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url || '');
      const probingSession =
        url.includes('/auth/session') || url.includes('/auth/sso/');
      if (!probingSession) {
        localStorage.removeItem('auth_token');
        const path = window.location.pathname;
        if (!path.startsWith('/login') && !path.startsWith('/auth/')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
